import { Route, Routes, Navigate } from "react-router-dom";

import LoginFlow from "../modules/login/LoginFlow";
import NewPassword from "../modules/login/NewPassword";
import CustomerSignUpFlow from "../modules/signup/CustomerSignUpFlow";
import InviteSignup from "../modules/signup/InviteSignup";
// import FillDetails from "../modules/signup/FillDetails"; // DEPRECATED: direct signup disabled
// import RequestJoin from "../modules/signup/RequestJoin"; // DEPRECATED: direct signup disabled
// import SignupFlow from "../modules/signup/SignupFlow"; // DEPRECATED: direct signup disabled

export default function UnauthorizedRoutes(props) {
  return (
    <>
      <div>
        <Routes>
          <Route path="*" element={<Navigate to="/login" />} />
          <Route path="/login" element={<LoginFlow />}></Route>
          {/* <Route path="/signup" element={<SignupFlow />}></Route> */}
          {/* <Route path="/fill-details" element={<FillDetails />}></Route> */}
          <Route path="account/login-pwd/new" element={<NewPassword />}></Route>
          <Route path="account/login-pwd/reset" element={<NewPassword reset={true} />}></Route>
          <Route path="/signup-invite" element={<InviteSignup />}></Route>
          {/* <Route path="/request-join" element={<RequestJoin />}></Route> */}
          <Route path="/signup-customer" element={<CustomerSignUpFlow />}></Route>
        </Routes>
      </div>
    </>
  );
}
